import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import { parseIncomingDate } from "./incomingPatientDates";

export default function IncomingDateInput({ defaultValue, value, name, onChange, ...props }) {
  const [selected, setSelected] = useState(() => parseIncomingDate(defaultValue));
  return (
    <DatePicker
      {...props}
      name={name}
      selected={value === undefined ? selected : parseIncomingDate(value)}
      dateFormat="dd/MM/yyyy"
      placeholderText="dd/mm/yyyy"
      strictParsing
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      onChange={(date) => {
        setSelected(date);
        onChange({ target: { name, value: date ? format(date, "yyyy-MM-dd") : "" } });
      }}
    />
  );
}
